// extracted by mini-css-extract-plugin
export var banner = "_oe-0";
export var settingRow = "_oe-2";
export var titleIcon = "_oe-1";